import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { ResetPassResponse } from '@app/utils/interfaces/passReset.interface';
import { NewPassResetBody } from '@app/utils/interfaces/passwordData.interface';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResetPassNewService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  sendPass(data: NewPassResetBody): Observable<ResetPassResponse | null> {
    return this.http.post<ResetPassResponse | null>(
      `${this.baseUrl}${ApiEndpoints.RESET_PASSWORD}`,
      data,
    );
  }
}
